module.exports = __webpack_public_path__ + "static/media/xtpx_m.60e49164.png";